import { SummaryCardVariant } from "./types";

export const SummaryCardVariantsThemeMap: Record<
  SummaryCardVariant,
  { backgroundColor: string; fontColor: string }
> = {
  [SummaryCardVariant.primary]: {
    backgroundColor: "$primary700",
    fontColor: "$textLight50"
  },
  [SummaryCardVariant.secondary]: {
    backgroundColor: "$primary50",
    fontColor: "$textLight800"
  },
  [SummaryCardVariant.blank]: {
    backgroundColor: "$primary50",
    fontColor: "$textLight800"
  }
};
